<xng-breadcrumb></xng-breadcrumb>
<div *ngIf="isLoading">
  <div *appSpinner="isLoading; message: 'Loading...'"></div>
</div>
<div class="container pt-4">
  <div class="card mb-4">
    <div class="card-body">
      <div class="d-flex justify-content-between">
        <h5 class="orange">Webhooks</h5>
        <div class="d-flex justify-content-end mb-3">
          <button (click)="onAddWebhook()" class="custom_button" translate><i
              class='bx orange bx-plus mr-1'></i>webhooks.newWebhook</button>
        </div>
      </div>
      <div *ngIf="!companyWebhooks?.length">No Webhooks.</div>
      <ul *ngIf="companyWebhooks?.length" class="p-0">

        <li class="d-flex justify-content-between align-items-center m-0 p-2 inventar_li"
          *ngFor="let wh of companyWebhooks">
          <span style="flex: 1">{{getEventName(wh.eventId)}}</span>
          <span style="flex: 1; text-align: end;">{{wh.baseUrl}}</span>
          <div class="dropdown d-flex justify-content-end ms-3">
            <i class='bx bx-dots-vertical-rounded orange' style="font-size: 1.5rem; padding: 5px; cursor: pointer;"
              id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false"></i>
            <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
              <li><a class="dropdown-item" (click)="onEditWebhook(wh)" translate>global.edit</a></li>
              <li><a class="dropdown-item" (click)="onDeleteWebhook(wh)" translate>global.delete<i
                    class="fa fa-trash ms-2"></i></a></li>
            </ul>
          </div>
        </li>

      </ul>
    </div>
  </div>
</div>

<app-modal (close)="toggleNewWebhook = !toggleNewWebhook" *ngIf="toggleNewWebhook">
  <div class="modal_container"
    style="text-align: initial; font-weight: 300 !important; letter-spacing: 1px; color: #15171a;">
    <div class="modal-header">
      <h4 class="modal-title orange" style="font-size: 1rem; font-weight: inherit;" translate>webhooks.newWebhook</h4>
    </div>
    <div class="modal-body">
      <form #webhookForm="ngForm" class="form-vehicle">
        <div class="form-group mb-2" *ngIf="webhookIsNew">
          <label translate>Event</label>
          <select class="form-select" aria-label="Select Event" #eventId="ngModel" [(ngModel)]="webhook.eventId"
            name="eventId">
            <option value="0" selected>Select Event</option>
            <option *ngFor="let event of this.events" value="{{event.id}}">{{event.name}}</option>
          </select>
        </div>

        <div class="form-group mb-2">
          <label translate>URL</label>
          <input type="text" #baseUrl="ngModel" autocomplete="off" [(ngModel)]="webhook.baseUrl" class="form-control"
            name="baseUrl">
        </div>

        <div class="form-group mb-2">
          <label translate>Authorization value in headers</label>
          <input type="text" #authorization="ngModel" autocomplete="off" [(ngModel)]="webhook.authorization" class="form-control"
            name="authorization">
        </div>

        <button class="custom_button w-100 mt-3" style="width: 120px;" *ngIf="webhookIsNew"
          (click)="addWebhook(webhookForm)" translate>global.save</button>
        <button class="custom_button w-100 mt-3" *ngIf="!webhookIsNew" (click)="editWebhook(webhookForm)"
          translate>global.edit</button>
      </form>
    </div>
  </div>
</app-modal>
